<img class="mobile-hide menu-bg" [src]="commonService.resource.image.menu_bg_desk" alt="">
<div class="app-container" [ngClass]="{'params-container': queryParams}">
    <div class="row m-0">
        <div class="col-md-2 p-0"></div>
        <div class="col-md-3 col-sm-12 p-0 about-container">
            <div class="menu-header menu-header-content py-3 px-4">
                <div class="py-3">
                    <span class="material-icons-outlined cursor" (click)="commonService.goBack()">
                    arrow_back
                </span>
                </div>
                <div class="">{{ "policyTerms.title" | translate}}</div>
            </div>
        </div>
        <div class="col-md-5 col-sm-12 p-0 about-container">
            <div class="overflow-auto about-content">
                <div class="about-container policy">
                    <mat-tab-group (selectedTabChange)="getContent($event)" [selectedIndex]="selectedTab.index">
                        <mat-tab [label]="('policyTerms.privacyPolicy' | translate)">
                            <div class="policy-content py-3 px-4" [ngClass]="{'height-with-menu' : !commonService.showMenubar()}">
                                {{content}}
                            </div>
                        </mat-tab>
                        <mat-tab [label]="('policyTerms.termsOfService' | translate)">
                            <div class="policy-content py-3 px-4" [ngClass]="{'height-with-menu' : !commonService.showMenubar()}">{{content}}</div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
        <div class="col-md-2 p-0"></div>
    </div>
</div>